import { render, staticRenderFns } from "./VuesticTabs.vue?vue&type=template&id=045ac4ac"
import script from "./VuesticTabs.vue?vue&type=script&lang=js"
export * from "./VuesticTabs.vue?vue&type=script&lang=js"
import style0 from "./VuesticTabs.vue?vue&type=style&index=0&id=045ac4ac&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045ac4ac')) {
      api.createRecord('045ac4ac', component.options)
    } else {
      api.reload('045ac4ac', component.options)
    }
    module.hot.accept("./VuesticTabs.vue?vue&type=template&id=045ac4ac", function () {
      api.rerender('045ac4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-tabs/VuesticTabs.vue"
export default component.exports